import React from "react";
import { Card, CardContent } from "../ui/card";
import { Users, Calendar, Trophy, TrendingUp } from "lucide-react";

const DashboardStats = ({ communities }) => {
  // Calculate stats
  const totalCommunities = communities.length;

  const totalMembers = communities.reduce((sum, community) => {
    return sum + (Number(community.member_count) || 0);
  }, 0);

  const activeSeasons = communities.reduce((sum, community) => {
    const seasons = Object.values(community.season || {});
    const active = seasons.filter(season => {
      const now = new Date();
      const start = new Date(season.start_date);
      const end = new Date(season.end_date);
      return now >= start && now <= end;
    });
    return sum + active.length;
  }, 0);

  const totalChallenges = communities.reduce((sum, community) => {
    const seasons = Object.values(community.season || {});
    return sum + seasons.reduce((seasonSum, season) => {
      return seasonSum + Object.keys(season.challenge || {}).length;
    }, 0);
  }, 0);

  const stats = [
    {
      title: "Total Communities",
      value: totalCommunities,
      icon: Users,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
      trend: null,
    },
    {
      title: "Total Members",
      value: totalMembers,
      icon: Users,
      color: "text-green-600",
      bgColor: "bg-green-50",
      trend: "+12%",
    },
    {
      title: "Active Seasons",
      value: activeSeasons,
      icon: Calendar,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
      trend: null,
    },
    {
      title: "Total Challenges",
      value: totalChallenges,
      icon: Trophy,
      color: "text-amber-600",
      bgColor: "bg-amber-50",
      trend: "+8%",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={index} className="overflow-hidden hover:shadow-lg transition-shadow">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 mb-1">
                    {stat.title}
                  </p>
                  <div className="flex items-baseline gap-2">
                    <h3 className="text-3xl font-bold text-gray-900">
                      {stat.value}
                    </h3>
                    {stat.trend && (
                      <span className="text-sm font-medium text-green-600 flex items-center">
                        <TrendingUp className="h-3 w-3 mr-1" />
                        {stat.trend}
                      </span>
                    )}
                  </div>
                </div>
                <div className={`${stat.bgColor} p-3 rounded-full`}>
                  <Icon className={`h-6 w-6 ${stat.color}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default DashboardStats;
